// to be considered since softUpdateLocale is not present in one-app-ducks
// should we use updateLocale instead of softUpdateLocale
import { updateLocale } from '@americanexpress/one-app-ducks';

const availableLanguages = {
  AT: ['de'],
  ES: ['es'],
  IN: ['en'],
  NL: ['nl'],
  NZ: ['en'],
  SE: ['sv'],
  SG: ['en'],
  FI: ['fi'],
  US: ['en'],
  HK: ['en', 'zh'],
  AU: ['en'],
  GB: ['en'],
  XA: ['en'],
  XB: ['en'],
  MX: ['es'],
  DE: ['de'],
  JP: ['ja'],
  FR: ['fr'],
  TW: ['zh'],
  CA: ['en', 'fr'],
  IT: ['it'],
  BE: ['fr', 'nl'],
  NO: ['nb'],
  CH: ['fr', 'de'],
  TH: ['en', 'th'],
  AR: ['es'],
  SA: ['en'],
  BH: ['en'],
  MY: ['en'],
  CN: ['zh'],
  ID: ['en'],
};

const regex = /[a-z]{2}-[A-Za-z]{2}/;

export const getCountryCodeFromLocale = (locale) => {
  const isValidLocaleFormat = regex.test(locale);
  let country = '';

  if (isValidLocaleFormat) {
    [, country] = locale.split('-');
  }

  return country.toUpperCase();
};

export const getBestAvailableLocale = (userLocale, productLocale) => {
  const [userLanguage] = userLocale.split('-');
  const [productLanguage] = productLocale.split('-');
  const productCountry = getCountryCodeFromLocale(productLocale);
  const productLanguages = availableLanguages[productCountry] || [];

  // fallback if nothing else can be applied
  let bestLang = userLocale;

  // if country is valid
  if (productLanguages.length > 0) {
    if (productLanguages.indexOf(userLanguage) !== -1) {
      // use current user language if its available to the country
      bestLang = `${userLanguage}-${productCountry}`;
    } else if (productLanguages.indexOf(productLanguage) !== -1) {
      // use product language if its available to the country
      bestLang = `${productLanguage}-${productCountry}`;
    } else {
      // use first available lang to country if valid country
      const [firstLang] = productLanguages;
      bestLang = `${firstLang}-${productCountry}`;
    }
  }

  return bestLang;
};

const updateProductLocale = ({ locale = 'en-US' }) => (dispatch, getState) => {
  const state = getState();
  const activeLocale = state.getIn(['intl', 'activeLocale']);
  const bestAvailableLocale = getBestAvailableLocale(activeLocale, locale);

  dispatch(updateLocale(bestAvailableLocale));
};

export default updateProductLocale;
